import O1HD from "../../engines/gameEngine";
import physics_tool from "../../engines/libs/physics_tool";
import utilsModel from "../../engines/libs/utilsModel";
import utilsView from "../../engines/libs/utilsView";
import { UI_Z_INDEX } from "../../engines/modules/uiModule";
import { CsvFileKind } from "../../modes/define/CsvFileKind";
import { FileKind } from "../../modes/define/FileKind";
import { MessageEventKind } from "../../modes/define/MessageEventKind";
import { TaskKind } from "../../modes/define/TaskKind";
import NormalGameManager from "../../modes/normalMode/manager/NormalGameManager";
import archeryArrow from "./archeryArrow";
import { archeryCoilderTag } from "./archeryConst";
import archeryLosePage from "./archeryLosePage";
import archeryRole from "./archeryRole";

const {ccclass, property} = cc._decorator;

@ccclass
export default class archeryGame extends cc.Component {

    @property({type:cc.Node,tooltip:"弓箭节点"})
    archeryNode:cc.Node = null;

    @property({type:cc.Node,tooltip:"箭节点"})
    arrowNode:cc.Node = null;

    @property({type:cc.Node,tooltip:"角色父节点"})
    roleNode:cc.Node = null;

    @property({type:cc.Node,tooltip:"背景节点"})
    bgNode:cc.Node = null;

    @property({type:cc.Node,tooltip:"加箭按钮"})
    btnAdd:cc.Node = null;

    @property({type:cc.Label,tooltip:"箭的数量文本"})
    lb_count:cc.Label = null;

    @property({type:cc.Node,tooltip:"贵妃"})
    guifeiNode:cc.Node = null;

    shotInvert:number = 200;

    lastShotTime:number = 0;

    arrowCount:number = 10;

    start(){
        this.updateArrowCount();
        this.updateArrowBtn();
        this.bgAddEvent();
        this.arrowNode.getComponent(archeryArrow).bindGame(this);
        physics_tool.openCollision();
    }

    bgAddEvent(){
        this.bgNode.on('touchend',this.onClickBg,this);
    }

    bgRemoveEvent(){
        this.bgNode.off('touchend',this.onClickBg,this);
    }

    onClickBg(){
        if(Date.now() - this.lastShotTime > 200){
            this.shotOneArrow();
            this.lastShotTime = Date.now();
        }
    }

    shotOneArrow(){
        if(this.arrowCount <= 0){
            O1HD.getModules().uiControlModule.showMessageBox("箭矢不足");
            return;
        }
        O1HD.getManagers().soundMgr.playSound("shot");
        let arrow:cc.Node = cc.instantiate(this.arrowNode);
        let as = arrow.getComponent(archeryArrow);
        as.bindGame(this);
        this.node.addChild(arrow);
        as.startMove();
        this.arrowCount --;
        this.updateArrowCount();
        this.updateArrowBtn();
    }

    killEnemyCount:number = 0;
    maxKillCount:number = 10;

    coilderOneNode(tag:number,node:cc.Node){
        switch(tag){
            case archeryCoilderTag.enemy:{
                // 如果全部杀掉则胜利，否则失败
                this.killEnemyCount ++;
                let killCount:number = this.killEnemyCount;
                let ns = node.getComponent(archeryRole);
                ns.death();
                if(killCount >= this.maxKillCount){
                    this.win();
                }
                break;
            }
            case archeryCoilderTag.friend:{
                // 失败
                let ns = node.getComponent(archeryRole);
                ns.death();
                this.lose();
                break;
            }
        }
    }

    isGameOver:boolean = false;

    win(){
        if(this.isGameOver){
            return;
        }
        this.isGameOver = true;
        this.bgRemoveEvent();
        this.scheduleOnce(()=>{
            // 胜利
            if(this.guifeiNode.getComponent(archeryRole).isDeath){
                this.showLose();
            }else{
                NormalGameManager._instance.taskDataManage.addNewFinishTask(TaskKind.TaskId.TASK_5);
                this.openMainEvent("11");
            }
        },2);
    }

    lose(){
        if(this.isGameOver){
            return;
        }
        this.isGameOver = true;
        this.bgRemoveEvent();

        this.scheduleOnce(()=>{ 
            this.showLose();
        },2);
    }

    showLose(){
        let fun = (node:cc.Node)=>{
            let ns = node.getComponent(archeryLosePage);
            ns.bindGame(this);
        }
        utilsView.openPopupLayerTwo(
            FileKind.PrefabFilePath.archeryLoseLayer,this.node,null,1,fun
        );
    }


    updateArrowCount(){
        this.lb_count.string = `×${this.arrowCount}`;
    }

    onBtnAddArrow(){
        utilsModel.loadAndShowVideoAdTrans(()=>{
            this.arrowCount += 5;
            this.updateArrowBtn();
            this.updateArrowCount();
        },()=>{},null,"拯救贵妃看广告增加箭矢");
    }

    updateArrowBtn(){
        if(this.arrowCount > 0){
            this.btnAdd.active = false;
        }else{
            this.btnAdd.active = true;
        }
    }

    roleAlive(){
        this.isGameOver = false;
        this.guifeiNode.getComponent(archeryRole).alive();
        this.bgAddEvent();
        if(this.killEnemyCount >= this.maxKillCount){
            this.win();
        }
    }

    onBtnClose(){
        O1HD.getManagers().soundMgr.playSound("anNiu");
        this.closeThis();
    }

    closeThis(){
        this.node.destroy();
    }

    onDisable(): void {
        physics_tool.closeCollision();
    }

    openMainEvent(id: string) {
        let fun = ()=> {
            NormalGameManager._instance.setGameData({saveArcheryFlag:true});
            O1HD.emit(MessageEventKind.EventName.UPDATE_CUPID_HOUSE_STATE);
            let addGoodsList = {};
            addGoodsList[30007] = 1;
            utilsView.openGetGoodsLayer(0, 0, addGoodsList);
            NormalGameManager._instance.onPushGoods(30007,1);
            this.closeThis();
        }
        let data = {
            id: id
            , eventCsv: CsvFileKind.CsvFile.MAIN_EVENT
            , eventArrCsv: CsvFileKind.CsvFile.MAIN_EVENT_ARRAY
            , onComplete: fun
            , exitLayer:()=>{}
        }
        utilsView.openEventLayer(
            null
            , data
            , UI_Z_INDEX.DIALOG
        );
    }

}
